import { getRefCompetences } from "../../../components/services/httpService";

export async function fetchRefCompetences() {
    const res = await getRefCompetences();
    if ( !res.ok ) {
        throw new Error( `Failed to fetch reference: competences: ${res.status}` );
    }
    return await res.json();
}

